import { type MetricField, type MyLensesOrganicStatsResponseEntry } from "../../gql-generated/types";
import { ejectTotalMetricValue } from "../filters";
import { generateDefaultMetrics } from "../generators";
import { type InsightsMetricsMap, type StatsItem } from "../models";

export const makeTotalMetricsMap = (
    responseEntryList: readonly MyLensesOrganicStatsResponseEntry[],
    metricsFields: MetricField[],
): InsightsMetricsMap<StatsItem> => {
    const defaults = generateDefaultMetrics(metricsFields);
    return metricsFields.reduce((metricsMap: InsightsMetricsMap<StatsItem>, metricField: MetricField) => {
        const metric = metricsMap[metricField];
        if (metric) {
            metric.totalValue = Number.parseFloat(ejectTotalMetricValue(responseEntryList, metricField));
        }
        return metricsMap;
    }, defaults);
};
